<template>
  <div>
  <p v-if="error">{{ error }}</p>
  <div>
    <h2 class="h2 pb-3 pt-3 border-bottom">New Scan</h2>
    <form ref="mainForm" class="needs-validation" @submit.prevent="submitForm">
      <div class="row g-3 mb-3">
        <div class="col-md-8">
          <label for="firstName" class="form-label">Enter URL:</label>
          <input class="form-control" id="url" type="text" ref="url" placeholder="e.g. https://www.mysite.com/blog/" value="" required>
          <div class="invalid-feedback">
            Valid URL is required
          </div>
        </div>
      </div>
      <div class="row g-3 mb-4">
        <div class="col-md-8">
          <label for="lastName" class="form-label">Your affiliate tag:</label>
          <input type="text" class="form-control" id="affiliateTag" placeholder="e.g. mytag-20" value="">
          <div class="invalid-feedback">
            Valid affiliate tag is required
          </div>
        </div>
      </div>
      <div class="row g-3 mb-4">
        <div class="col-md-8">
          <button class="w-100 btn btn-primary btn-lg" type="submit">Start Scan</button>
        </div>
      </div>
    </form>
  </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      error: null
    }
  },
  methods: {
    submitForm(event) {
        if (! this.$refs.mainForm.checkValidity()) {
          event.preventDefault()
          event.stopPropagation()
          return;
        }

        this.$refs.mainForm.classList.add('was-validated')
        this.startCrawl();
    },
    startCrawl() {
      const url = this.$refs.url.value;
      let extraParams = "";
      for (const queryParam in this.$route.query) {
        extraParams += "&" + queryParam + "=" + this.$route.query[queryParam];
      }

      fetch(this.backendHost + '/create?url=' + url + extraParams).then(response => {
        if (! response.ok) {
          throw new Error('Oops... something went wrong!');
        }
        return response.json();
      }).then(response => {
        console.log(response)
        if (response.error) {
          this.error = response.error;
          return;
        }

        // Successful response
        this.$router.push({
          name: 'productResults',
          params: {
            crawlId: response.identifier,
            newCrawl: true
          }
        })
      })
      .catch(error => {
        this.error = error.message;
      })
    }
  }
}
</script>
